import type { EmailSettingsDto, JustCallSettingsDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EmailSettingsService {
  apiName = 'Default';
  

  getJustCallSettings = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, JustCallSettingsDto>({
      method: 'GET',
      url: '/api/app/email-settings/get-just-call-settings',
    },
    { apiName: this.apiName,...config });
  

  getSettings = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EmailSettingsDto>({
      method: 'GET',
      url: '/api/app/email-settings/get-settings',
    },
    { apiName: this.apiName,...config });
  

  setJustCallSettingsByJustCallSettings = (justCallSettings: JustCallSettingsDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/email-settings/set-just-call-settings',
      body: justCallSettings,
    },
    { apiName: this.apiName,...config });
  

  setSettingsByEmailSettings = (emailSettings: EmailSettingsDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/email-settings/set-settings',
      body: emailSettings,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
